import { UserLoginResponseBody } from '../types/generated/login_post.response';
import { UserLoginContentBody } from '../types/generated/login_post.content';
import apiEndpoints from '../../apiEndpoints';
import { fetcher } from '../utils/fetchers/fetcher';

export const requestLogin = (
  body: UserLoginContentBody,
  token: string | null,
  forceHeader?: string
): Promise<UserLoginResponseBody> =>
  fetcher<UserLoginResponseBody>(
    apiEndpoints.routes.login,
    'POST',
    token,
    forceHeader,
    undefined,
    body
  );
